import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import SafeAnchor from '../utils/bootstrap/SafeAnchor';
import { createChainedFunction } from '../utils/createChainedFunction';
import { IMenuItemProps } from './types';

export class MenuItem extends Component<PropsWithChildren<IMenuItemProps>, {}> {
  public static defaultProps = {
    bsClass: 'dropdown',
    disabled: false,
    divider: false,
    header: false,
    releaseFocusAfterSelect: false,
  };

  public handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const { href, disabled, onClick, onSelect, eventKey } = this.props;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (eventKey && onSelect) {
      onSelect(eventKey, event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  public render() {
    const { className, active, disabled, divider, header, ...props } = this.props;

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      props.children = undefined;

      return (
        <li
          {...(props as any)} // tslint:disable-line
          role="separator"
          tabIndex={'-1'}
          className={classNames(className, 'divider')}
        />
      );
    }

    if (header) {
      return (
        <li
          {...(props as any)} // tslint:disable-line
          role="heading"
          tabIndex={'-1'}
          className={classNames(className, 'dropdown-header')}
        />
      );
    }

    return (
      <li role="presentation" className={classNames(className, 'dropdown', { active, disabled })}>
        <SafeAnchor
          {...(props as any)} // tslint:disable-line
          role="menuitem"
          disabled={disabled}
          onClick={this.handleClick}
        />
      </li>
    );
  }
}

export default MenuItem;
